// Safe wrapper around window.umami - no-ops if script not loaded or DSN not configured.
// All calls are fire-and-forget; never throws.

type Props = Record<string, string | number | boolean>;

export function track(event: string, props?: Props): void {
    try {
        const u = (window as any).umami;
        if (typeof u === 'object' && typeof u.track === 'function') {
            u.track(event, props);
        }
    } catch (_) { /* intentionally empty - analytics must never throw */ }
}
